var styles = {
  "FieldFeedback": "pb-FieldFeedback__FieldFeedback",
  "container": "pb-FieldFeedback__container",
  "icon": "pb-FieldFeedback__icon",
  "message": "pb-FieldFeedback__message"
};
export default styles;